import React from 'react';
import MainContext, { MainContextProvider } from 'context/main-context';

type GlobalContextProps = {
  children: React.ReactNode;
};

const GlobalContext = ({ children }: GlobalContextProps) => {
  return <MainContextProvider>{children}</MainContextProvider>;
};
export default GlobalContext;
export { MainContext };
